import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_KEYS } from '@/language/keys';
import { reloadPageForWAF } from '@/services/waf/reloadPageForWAF';
import { recordWAFTelemetry } from '@/services/waf/telemetry';
import { WAFTelemetryOutcomeExtra, WAFTelemetryPhase } from '@/services/waf/types';
import { TextStdRg } from '@/UI/AppTypography/AppTypography';
import { ButtonContained } from '@/UI/Buttons/AppButton';
import { FlexCol } from '@/UI/styles';
import { isFigmaEmbedContext } from '@/utils/auth.utils';

export const WAF_INTERACTIVE_HELP_DELAY_MS = 60_000;

/** Mount only while the interactive challenge is on screen; offers a reload after WAF_INTERACTIVE_HELP_DELAY_MS. */
export function WAFInteractiveHelp() {
  const { t } = useTranslation();
  const [isShowing, setIsShowing] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsShowing(true);
      recordWAFTelemetry({
        phase: WAFTelemetryPhase.Clearance,
        outcome: WAFTelemetryOutcomeExtra.InteractiveHelpShown,
      });
    }, WAF_INTERACTIVE_HELP_DELAY_MS);
    return () => clearTimeout(timeoutId);
  }, []);

  if (!isShowing) {
    return null;
  }

  return (
    <FlexCol sx={{ gap: 1 }}>
      <TextStdRg>{t(I18N_KEYS.SECURITY_CHALLENGE.INTERACTIVE_HELP)}</TextStdRg>
      <ButtonContained
        mode="outlined"
        isFigmaTheme={isFigmaEmbedContext() ? true : undefined}
        onClick={() => {
          recordWAFTelemetry({
            phase: WAFTelemetryPhase.Clearance,
            outcome: WAFTelemetryOutcomeExtra.InteractiveHelpReload,
          });
          reloadPageForWAF();
        }}
      >
        {t(I18N_KEYS.SECURITY_CHALLENGE.RELOAD)}
      </ButtonContained>
    </FlexCol>
  );
}
